// Shared canvas helpers for drawing tools.

export function extendToBox(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  w: number,
  h: number
): [number, number, number, number] {
  // return a segment of the infinite line clipped to [0,w]x[-big,big] box
  const dx = x2 - x1;
  const dy = y2 - y1;
  if (dx === 0 && dy === 0) return [x1, y1, x2, y2];
  const big = 1e5;
  return [x1 - dx * big, y1 - dy * big, x2 + dx * big, y2 + dy * big];
}

export function rayEnd(x1: number, y1: number, x2: number, y2: number): [number, number] {
  const dx = x2 - x1;
  const dy = y2 - y1;
  const big = 1e5;
  return [x2 + dx * big, y2 + dy * big];
}

export function drawArrowHead(
  ctx: CanvasRenderingContext2D,
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  size: number,
  color: string
) {
  const ang = Math.atan2(y2 - y1, x2 - x1);
  const a = Math.PI / 7;
  ctx.save();
  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.moveTo(x2, y2);
  ctx.lineTo(x2 - size * Math.cos(ang - a), y2 - size * Math.sin(ang - a));
  ctx.lineTo(x2 - size * Math.cos(ang + a), y2 - size * Math.sin(ang + a));
  ctx.closePath();
  ctx.fill();
  ctx.restore();
}

export function labelBox(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  lines: string[],
  opts: { bg: string; fg: string; font?: string; align?: "left" | "center"; pad?: number } = { bg: "#000", fg: "#fff" }
) {
  const font = opts.font ?? "11px -apple-system, system-ui, sans-serif";
  const pad = opts.pad ?? 6;
  ctx.save();
  ctx.font = font;
  let maxW = 0;
  for (const l of lines) maxW = Math.max(maxW, ctx.measureText(l).width);
  const lh = 15;
  const boxW = maxW + pad * 2;
  const boxH = lines.length * lh + pad * 2 - 3;
  let bx = x;
  if (opts.align === "center") bx = x - boxW / 2;
  ctx.fillStyle = opts.bg;
  roundRect(ctx, bx, y, boxW, boxH, 4);
  ctx.fill();
  ctx.fillStyle = opts.fg;
  ctx.textBaseline = "top";
  ctx.textAlign = "left";
  for (let i = 0; i < lines.length; i++) {
    ctx.fillText(lines[i], bx + pad, y + pad + i * lh);
  }
  ctx.restore();
  return { x: bx, y, w: boxW, h: boxH };
}

export function roundRect(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number) {
  const rr = Math.min(r, Math.abs(w) / 2, Math.abs(h) / 2);
  ctx.beginPath();
  ctx.moveTo(x + rr, y);
  ctx.arcTo(x + w, y, x + w, y + h, rr);
  ctx.arcTo(x + w, y + h, x, y + h, rr);
  ctx.arcTo(x, y + h, x, y, rr);
  ctx.arcTo(x, y, x + w, y, rr);
  ctx.closePath();
}
